import React from 'react';
import {Query} from 'react-apollo'
import moment from 'moment'

import Loading from '../Loading'

import QUERY from '../../../queries/server/annual_leave_this_week'

const WhosOff = (props) => {
  return (
    <Query query={QUERY} fetchPolicy="network-only">
      {({loading, error, data}) => {

        if (loading) return <Loading />

        if (!data.annual_leave_this_week.length) {
          return (
            <div className="d-flex align-items-center justify-content-center">
              <span className="lead">Nobody is off this week</span>
            </div>
          )
        }

        return (<div className="d-flex flex-column">
          {data.annual_leave_this_week.map(al => (
            <div className="d-flex flex-column border-bottom p-3">
              <span className="lead">{al.user.full_name}</span>
              <small>
                {moment(al.start_date).format('Do MMM YY')} ({al.start_of_day ? 'Start of Day' : 'Afternoon'}) 
                to{' '}
                {moment(al.end_date).format('Do MMM YY')} ({al.end_of_day ? 'End of Day' : 'Afternoon'})
              </small>
            </div>
          ))}
        </div>)
      }}
    </Query>
  )
}

export default WhosOff
